export default "__VITE_ASSET__478ff6bb__"